export default __webpack_public_path__ + "static/media/video.16721c2c.svg";